<div class="profile" *ngIf="coach">
  <!-- Profile banner with name -->
  <div class="profile__banner" *ngIf="!isClub">
    <div class="profile__banner-content">
      <h3>
        <span>{{ coach.first_name }}</span>
        <strong>{{ coach.last_name }}</strong>
      </h3>
    </div>
  </div>

  <div class="profile__body">
    <!-- Action buttons and section title -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Personal details</h4>
      <div class="profile__body-header-actions">
        <button
          *ngIf="canApprove"
          kendoButton
          themeColor="primary"
          (click)="approveCoach()"
          icon="check"
        >
          <span>Approve coach</span>
        </button>
        <button
          *ngIf="canEdit"
          kendoButton
          themeColor="base"
          [routerLink]="['/app/coach', this.id]"
          icon="edit"
        >
          <span>Edit profile</span>
        </button>
        <button
          *ngIf="canDelete"
          kendoButton
          (click)="deleteCoach()"
          themeColor="dark"
          icon="trash"
        >
          <span>Delete profile</span>
        </button>
      </div>
    </div>

    <!-- Personal information cards -->
    <div class="box" *ngIf="!isClub">
      <div class="box__section">
        <div class="box__section-title">Ethnicity</div>
        <div class="box__section-value">{{ ethnic_identity || 'Not specified' }}</div>
      </div>
      <div class="box__section">
        <div class="box__section-title">Gender</div>
        <div class="box__section-value">{{ CoachGender[coach.gender] || 'Not specified' }}</div>
      </div>
      <div class="box__section">
        <div class="box__section-title">Date of birth</div>
        <div class="box__section-value">{{ coach.dob | date:'mediumDate' || 'Not specified' }}</div>
      </div>
      <div class="box__section">
        <div class="box__section-title">FA number</div>
        <div class="box__section-value">{{ coach.fa_number || 'Not specified' }}</div>
      </div>
    </div>

    <!-- Highest qualification highlight -->
    <p *ngIf="!isClub && highestCoreQualification">
      <b>Highest core qualification:</b> {{highestCoreQualification.course.name}}
    </p>

    <!-- Experiences section -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Relevant experiences</h4>
    </div>

    <table *ngIf="coach.coachExperiences && coach.coachExperiences.length > 0">
      <thead>
        <tr>
          <th>Title</th>
          <th>Company/Club name</th>
          <th>Start date</th>
          <th>End date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let experience of coach.coachExperiences">
          <td>{{ experience.role_title }}</td>
          <td>{{ experience.company_name }}</td>
          <td>{{ experience.start_date | date:'mediumDate' }}</td>
          <td>{{ experience.end_date | date:'mediumDate' || 'Present' }}</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!coach.coachExperiences || coach.coachExperiences.length === 0" class="empty-state">
      No relevant experiences added yet.
    </div>

    <!-- Education section -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Relevant education</h4>
    </div>

    <table *ngIf="coach.coachEducations && coach.coachEducations.length > 0">
      <thead>
        <tr>
          <th>Field</th>
          <th>Grade</th>
          <th>Start date</th>
          <th>End date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let experience of coach.coachEducations">
          <td>{{ experience.field }}</td>
          <td>{{ experience.grade }}</td>
          <td>{{ experience.start_date | date:'mediumDate' }}</td>
          <td>{{ experience.end_date | date:'mediumDate' || 'Present' }}</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!coach.coachEducations || coach.coachEducations.length === 0" class="empty-state">
      No relevant education added yet.
    </div>

    <!-- Qualifications section -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Relevant qualifications</h4>
    </div>

    <table *ngIf="coach.coachQualifications && coach.coachQualifications.length > 0">
      <thead>
        <tr>
          <th>Name</th>
          <th *ngIf="!isClub">Completion country</th>
          <th *ngIf="!isClub">Completion year</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let experience of coach.coachQualifications">
          <td>{{ experience.course.name }}</td>
          <td *ngIf="!isClub">{{ experience.country?.name || 'Not specified' }}</td>
          <td *ngIf="!isClub">{{ experience.completionYear || 'Not specified' }}</td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="!coach.coachQualifications || coach.coachQualifications.length === 0" class="empty-state">
      No relevant qualifications added yet.
    </div>

    <!-- Departments section -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Departments</h4>
    </div>

    <div class="chip-container">
      <kendo-chip
        *ngFor="let desiredDepartment of departments"
        [label]="desiredDepartment.department.name"
        appearance="filled"
      >
      </kendo-chip>
      <div *ngIf="!departments || departments.length === 0" class="empty-state">
        No departments selected.
      </div>
    </div>

    <!-- Regions section -->
    <div class="profile__body-header">
      <h4 class="profile__body-header-title">Regions</h4>
    </div>

    <div class="chip-container">
      <kendo-chip
        *ngFor="let desiredRegion of regions"
        [label]="desiredRegion.region.name"
        appearance="filled"
      >
      </kendo-chip>
      <div *ngIf="!regions || regions.length === 0" class="empty-state">
        No regions selected.
      </div>
    </div>
  </div>
</div>
